import React from 'react'
import { Link } from 'react-router-dom'

const RouterLinkTemplate = ({ Path, Target, inEditMode, children, className, ...rest }) => {
  if (!Path) return <>{children}</>
  if (inEditMode) return <a {...rest} className={className} href={Path}>{children}</a>
  if (Target) return <a {...rest} className={className} href={Path} target={Target}>{children}</a>
  const path = Path.toLowerCase()
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('tel:') || path.endsWith('.pdf')) {
    return <a {...rest} className={className} href={Path}>{children}</a>
  }

  return <Link {...rest} className={className} to={Path}>{children}</Link>
}

export default React.memo(RouterLinkTemplate)
